export type FaqItem = {
  question: string
  answer: string
}

export const faq: FaqItem[] = [
  {
    question: 'Combien de temps avant votre arrivée ?',
    answer:
      'Depuis Maisons-Laffitte, je suis sur place en 20 à 30 minutes dans la boucle de Seine, et en moins d’une heure sur Paris et la proche banlieue. Je vous donne un créneau réel au téléphone, pas une promesse impossible.',
  },
  {
    question: 'Le prix annoncé au téléphone est-il le prix final ?',
    answer:
      'Oui. Je vous annonce un montant après quelques questions sur votre porte et votre serrure, puis je vous remets un devis écrit sur place. Rien ne commence avant votre signature, et aucun supplément n’apparaît sur la facture.',
  },
  {
    question: 'Ma porte va-t-elle être abîmée ?',
    answer:
      'Dans la grande majorité des cas, une porte simplement claquée s’ouvre sans aucune dégradation. Si le perçage du cylindre est inévitable, je vous l’explique avant, et je vous propose le remplacement dans la même intervention.',
  },
  {
    question: 'Travaillez-vous avec les assurances ?',
    answer:
      'Oui. Après une effraction, je sécurise l’ouverture le jour même et je fournis une facture détaillée, avec photos si besoin, directement utilisable pour votre déclaration de sinistre.',
  },
  {
    question: 'Intervenez-vous pour les professionnels et les syndics ?',
    answer:
      'Oui : commerces, bureaux, copropriétés. Je réalise les mises en passe d’immeuble, l’entretien des serrures de hall et les rideaux métalliques, avec facturation au nom de la société ou du syndic.',
  },
  {
    question: 'Quels moyens de paiement acceptez-vous ?',
    answer:
      'Carte bancaire sur place, espèces, virement et chèque. La facture vous est remise immédiatement, avec la TVA détaillée.',
  },
]
